module.exports = __webpack_public_path__ + "static/media/checked-white.2e75e5fe.svg";